namespace $.$$ {
	export class $shm_hitalama_settings_interface extends $.$shm_hitalama_settings_interface {
		static touch_hints_enabled( next?: boolean ): boolean {
			const profile = this.$.$shm_hitalama_profile.current()
			if( !profile ) {
				if( next !== undefined ) throw new Error( 'Войдите в аккаунт, чтобы сохранить настройки интерфейса.' )
				return true
			}
			return profile.touch_hints_enabled( next )
		}

		touch_hints_enabled( next?: boolean ): boolean {
			return this.$.$shm_hitalama_settings_interface.touch_hints_enabled( next )
		}
	}
}
